import { makeStyles } from 'tss-react/mui';

export default makeStyles()(theme => ({
    cardButton: {
        width: '100%',
        textAlign: "initial"
    },
    cardTitle: ({ align }) => ({
        textAlign: align,
        overflowWrap: 'anywhere',
    }),
    itemTitle: {
        overflowWrap: 'anywhere'
    },
    delete: {
        color: 'rgba(0, 0, 0, 0.54)'
    },
    [theme.breakpoints.down('lg')]: {
        title: {
            fontSize: '1.25rem',
            fontWeight: 500
        }
    },
    cardIconWrapper: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center'
    },
    cardIcon: {
        maxHeight: '35px',
    },
    actionPanel: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    promo: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    promotionText: {
        color: 'white'
    }
}));